<template>
  <div :class="{ 'full-height': showExtended }">
    <div class="w-full h-full flex flex-col">
      <p class="font-bold mb-4">How many people do you have employed?</p>
      <Transition name="fade" mode="out-in">
        <div v-if="showExtended" key="input" class="flex flex-col justify-between flex-grow">
          <DrInput v-model="employeeCount" type="number" placeholder="e.g. 138" />
          <RouterLink to="/personal-details" tag="DrButton" class="btn-block btn-blue">
            Continue
          </RouterLink>
        </div>
        <div v-else key="buttons">
          <DrButton
            v-for="(amount, index) in employeeCountOptions"
            :key="amount.value"
            :data-cy="`btn-employee-count-${index}`"
            :value="amount.value"
            class="mb-4 btn-block btn-blue"
            :class="{
              isActive: amount.value === parseInt(employeeCount, 10),
              'opacity-50': employeeCount,
            }"
            @click.prevent="selectEmployeeCount(amount.value)"
          >
            {{ amount.key }}
          </DrButton>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showExtended: false,
      employeeCountOptions: [
        {
          key: 'Just me!',
          value: 1,
        },
        {
          key: 'Up to 3 employees',
          value: 3,
        },
        {
          key: 'Up to 6 employees',
          value: 6,
        },
        {
          key: 'Up to 9 employees',
          value: 9,
        },
        {
          key: 'Up to 20 employees',
          value: 20,
        },
        {
          key: 'More than 20 employees',
          value: 21,
        },
      ],
    }
  },
  computed: {
    employeeCount: {
      get () {
        return this.$store.getters.getEmployeeCount
      },
      set (value) {
        this.$store.commit('updateEmployeeCount', value)
      },
    },
  },
  mounted () {
    if (this.employeeCount) {
      if (!this.employeeCountOptions.filter(item => item.value === this.employeeCount).length) { this.showExtended = true }
    }
  },
  methods: {
    selectEmployeeCount (amount) {
      if (amount <= 20) {
        this.employeeCount = amount
        this.$router.push('/personal-details')
      } else {
        this.showExtended = true
      }
    },
  },
}
</script>
